export default __webpack_public_path__ + "static/vojtech-filip-611f75d9b202777b574d369b31ef3093.avif";